import { render, staticRenderFns } from "./SchoolHeader.vue?vue&type=template&id=643f7f3f&scoped=true"
import script from "./SchoolHeader.vue?vue&type=script&lang=js"
export * from "./SchoolHeader.vue?vue&type=script&lang=js"
import style0 from "./SchoolHeader.vue?vue&type=style&index=0&id=643f7f3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_729849d24245ac5da8661ad62b6d24d8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f7f3f",
  null
  
)

export default component.exports